import React, { useEffect, useState } from 'react';
import { Font, View, Text, StyleSheet, Page } from '@react-pdf/renderer';
import FeedbackRow from './feedbackRow';



const StudentFeedback = ({ feelAtSchool }) => {
    const [talkAboutFeeling, setTalkAboutFeeling] = useState(10);
    const [calmDown, setCalmDown] = useState(0);
    const [understandFriendsFeeling, setUnderstandFriendsFeeling] = useState(0);
    const [respectEveryoneOpinion, setRespectEveryoneOpinion] = useState(0);
    const [helpFriendsMakeupAfterFight, setHelpFriendsMakeupAfterFight] = useState(0);
    const [makeFeelBetter, setMakeFeelBetter] = useState(0);
    const [doWellAtSchool, setDoWellAtSchool] = useState(0);

    useEffect(() => {
        if (feelAtSchool) {
            setTalkAboutFeeling(feelAtSchool.talkAboutFeeling);
            setCalmDown(feelAtSchool.calmDown);
            setUnderstandFriendsFeeling(feelAtSchool.understandFriendsFeeling);
            setRespectEveryoneOpinion(feelAtSchool.respectEveryoneOpinion);
            setHelpFriendsMakeupAfterFight(feelAtSchool.helpFriendsMakeupAfterFight);
            setMakeFeelBetter(feelAtSchool.makeFeelBetter);
            setDoWellAtSchool(feelAtSchool.doWellAtSchool);
        }
    }, [feelAtSchool]);



    return (
        <Page>
            <View style={[styles.container]}>
                <View style={[styles.header]}>
                    <View style={[styles.headerRow]}>
                        <Text style={[styles.textHeadingPage, { color: 'darkorange' }]}>
                            Part A (3)
                        </Text>
                    </View>
                    <View style={[styles.headerRow]}>
                        <Text style={[styles.textHeading, { color: 'darkOrange' }]}>
                            How do I feel at School
                        </Text>
                    </View>
                </View>
                <View style={[styles.section]}>
                    <View style={[styles.feedbackDescSection]}>
                        <View style={[styles.feedbackLabelSection]}>
                            <Text style={[styles.textInstruction, { color: 'black' }]}>
                                {"Circle the most appropriate option for each sentence."}
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.feedbackSection]}>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"1"}
                                qusLabel={"I can talk about how I feel, e.g., happy, confident, upset or angry."}
                                value={10}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"2"}
                                qusLabel={"I can calm myself down during difficult situations."}
                                value={20}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"3"}
                                qusLabel={"I can understand how my friends feel."}
                                value={10}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"4"}
                                qusLabel={"I respect everyone's opinions."}
                                value={20}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"5"}
                                qusLabel={"I can help my friends make up after a fight."}
                                value={40}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"6"}
                                qusLabel={"When someone is sad, I can make them feel better."}
                                value={30}
                            />
                        </View>
                        <View style={[styles.feedbackRow]}>
                            <FeedbackRow
                                qusNo={"7"}
                                qusLabel={"I think I do well at school."}
                                value={20}
                            />
                        </View>
                    </View>
                </View>
                <View style={styles.divider} />
            </View>
        </Page>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "column",
    },
    header: {
        flex: 2,
        flexDirection: "column",
        // border: '1px solid green',
    },
    headerRowPage: {
        flex: 2,
        justifyContent: "center",
        // border: '1px solid blue',
    },
    headerRow: {
        flex: 1,
        justifyContent: "center",
        // border: '1px solid red',
    },
    textHeadingPage: {
        // marginTop: 100,
        fontSize: 16,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#e36c0a',
        fontFamily: 'Helvetica-Bold',
        // borderRadius: 6,
        paddingHorizontal: 10,
        paddingTop: 30
    },
    textHeading: {
        // marginTop: 100,
        fontSize: 16,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#e36c0a',
        fontFamily: 'Helvetica-Bold',
        // borderRadius: 6,
        padding: 10,
    },
    section: {
        flex: 13,
        flexDirection: "column",
        marginHorizontal: 30,
    },
    textInstruction: {
        fontSize: 16,
        textAlign: 'left',
        marginVertical: 2,
    },
    divider: {
        backgroundColor: 'darkorange',
        width: '90%',
        height: 1,
        position: 'absolute',
        bottom: 30,
        left: '5%',
    },
    feedbackSection: {
        flexDirection: "column",
        borderTop: '1px solid darkorange',
        padding: 0,
        marginTop: 20,
    },
    feedbackRow: {
        flexDirection: "column",
        padding: 0,
        margin: 0,
    },
    feedbackDescSection: {
        height: "40px",
        flexDirection: "row",
        justifyContent: "center",
        paddingHorizontal: "5px",
        // border: '1px solid darkorange',
    },
    feedbackLabelSection: {
        flex: 1,
        // paddingRight: "5px",
    },
});

export default StudentFeedback;